module.exports = __webpack_public_path__ + "static/media/file.62663374.svg";